import type { CampaignAnalytics } from '../../../api/client.ts';
import { BREAKDOWN_LABELS, formatMetric, sliceLabel } from './analytics.ts';

/**
 * The KPIs split by channel, variant, platform or locale (BB-104, AN-002): the same formulas as the tiles over each
 * slice; control is never a row. Conversion windows know the channel of first receipt and the variant only, so by
 * platform and locale conversions are a dash with a note.
 */
export function BreakdownTable({ data }: { data: CampaignAnalytics }) {
  const label = BREAKDOWN_LABELS[data.breakdown];
  const noConversions = data.breakdown === 'platform' || data.breakdown === 'locale';
  if (data.rows.length === 0) return <p className="hint">Nothing was sent in this period, so there is nothing to split by {label.toLowerCase()}.</p>;
  return (
    <div className="push-table-scroll">
      <table className="table push-table" aria-label={`Metrics by ${label.toLowerCase()}`}>
        <thead>
          <tr>
            <th scope="col">{label}</th>
            {data.kpis.map((k) => (
              <th key={k.key} scope="col">
                {k.title.en}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((row) => (
            <tr key={row.key ?? '∅'}>
              <th scope="row">{sliceLabel(data.breakdown, row.key, data)}</th>
              {data.kpis.map((k) => (
                <td key={k.key}>{formatMetric(k.format, row.metrics[k.key])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {noConversions && <p className="hint">Conversions cannot be split by {label.toLowerCase()}: a conversion window knows only the channel of first receipt and the variant.</p>}
      {data.breakdown === 'channel' && <p className="hint">A conversion counts towards the channel that first reached the user in its window.</p>}
    </div>
  );
}
